module.exports = "<div class=\"modal-header\">\n\n</div>\n<div class=\"modal-body\">\n    <div class=\"hp-error\">\n        <img class=\"error-image\" src=\"/src/assets/images/icon-guy.png\" alt=\"Error\" />\n        <h1>Oops! That wasn't right.</h1>\n        <br/>\n        <h3>User needs to sign Terms & Conditions</h3>\n        <br/><br/>\n        <p>Please contact us at 844-722-7759 <br/> or <a href=\"mailto:info@heroprogram.com\" class=\"link\">info@heroprogram.com</a> if you have any questions.</p>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/specialNotice/shouldSignTC.html
// module id = 947
// module chunks = 1